import React from "react";
import { useRecordContext } from "react-admin";

const ParticipantsField = () => {
  const record = useRecordContext();
  return record ? (
    <span>
      {record.participants.map((participant) => participant.name).join(", ")}
    </span>
  ) : null;
};

ParticipantsField.defaultProps = { label: "Participants" };

export default ParticipantsField;
